export const environment = {
  production: true,
  apiUrl: 'https://bhcfbx3s1a.execute-api.eu-west-1.amazonaws.com',
  payfast: {
    merchantId: '13541555',
    merchantKey: 'gldy6m1fhx2pf',
    sandbox: false,
  },
}
